export const SELECTOR_THEMES = {
  "/tiktok": { left: "#25d8d3", right: "#ef7b91" },
  "/youtube": { left: "#a9232d", right: "#ff6258" },
  "/twitch": { left: "#6531a8", right: "#b185ff" },
  "/mindshare": { left: "#ff6258", right: "#22d6ff" },
  "/steam": { left: "#245e87", right: "#66c9f4" },
  "/xbox": { left: "#246442", right: "#62d884" },
  "/discord": { left: "#5458ad", right: "#a0a4ff" },
};

export function selectorThemeStyle(route) {
  const theme = SELECTOR_THEMES[route];
  return { "--bs-edge-left": theme.left, "--bs-edge-right": theme.right };
}
